import styles from '@features/b2b-contact-form/styles/B2BLanguageDropdown.module.css';
import React from 'react';

import { setUserSelectedLanguageManually } from '@entities/dcb';
import { LanguageSelector } from '@shared/assets/svgs/LanguageSelector';
import { changeLanguage } from '@entities/language/store';
import { getDirFromLocale } from '@entities/language/model/utils';
import { LogService } from '@shared/services/LogService';
import { AR_lang, EN_lang } from '@entities/language';
import { useAtomValue } from 'jotai';
import { languageAtom } from '@shared/store/slice-atoms';
import { setHtmlDirection } from '@shared/utils';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';

export const B2BLanguageDropdown: React.FC = () => {
  const { i18n } = useTranslation();
  const language = useAtomValue(languageAtom);

  const nextLang = language.locale === EN_lang.lang ? AR_lang : EN_lang;

  const handleChangeLanguage = () => {
    const nextLang = language.locale === EN_lang.lang ? AR_lang : EN_lang;

    i18n.changeLanguage(nextLang.lang);
    changeLanguage({
        locale: nextLang.lang,
        displayName: nextLang.name,
        direction: nextLang.direction,
      });

    const dir = getDirFromLocale(nextLang.lang);
    setHtmlDirection(dir);

    setUserSelectedLanguageManually();
    LogService.languageChangedManually(nextLang.lang);
  };

  return (
    <Button variant={'default'} onClick={handleChangeLanguage}>
      <div className={styles.dropdown_selected_item}>
        <LanguageSelector />
        <span>{nextLang.name}</span>
      </div>
    </Button>
  );
};
